import React from 'react';
import styled from 'styled-components';
import { ReactComponent as RadarImage } from '../images/radar.svg';
import { black, white } from 'styles/Colors';

export const Header = styled.div`
  background-image: linear-gradient(95deg, #d0021b, rgba(208, 2, 27, 0.82));
  height: 24px;
  padding-left: 12px;
  border-radius: 5px;
  svg {
    path {
      fill: ${white};
    }
  }
`;

export const Text = styled.div`
  font-family: Lato;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.46px;
  color: ${white};
`;

export const StyledRadarImage = styled((props) => <RadarImage {...props} />)`
  display: block;
  margin: 57px auto 41px auto;
`;

export const TextBox = styled.div`
  font-family: Lato;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  letter-spacing: 0.46px;
  text-align: center;
  color: ${black};
  margin-bottom: 154px;
  .faq {
  }
`;

export const Faq = styled.u`
  cursor: pointer;
`;
